/**
 * Validates URLs used with window.open for document preview.
 * Relative strings (e.g. "null") resolve against the current /docs path and produce broken routes.
 */
export function isSafeDocumentViewUrl(uri: string | null | undefined): boolean {
    if (uri == null || typeof uri !== 'string') {
        return false;
    }
    const trimmed = uri.trim();
    if (!trimmed || trimmed === 'null' || trimmed === 'undefined') {
        return false;
    }
    try {
        const parsed = new URL(trimmed);
        return parsed.protocol === 'https:' || parsed.protocol === 'http:';
    } catch {
        return false;
    }
}
